import {
  appName,
  appUrl,
  contactUrl,
  userFaqUrl,
  creatorAndBusinessFaqUrl,
  creatorRegistrationUrl,
  creatorBankAccountRegistrationUrl,
  socialTwitterUrl,
  socialFacebookUrl,
  socialInstagramUrl,
  socialYoutubeUrl,
  hashtag,
  metaDescription,
} from './brand'

// ブランド設定から取得
export const APP_NAME = appName
export const APP_URL = appUrl
export const CONTACT_URL = contactUrl
export const USER_FAQ_URL = userFaqUrl
export const CREATOR_AND_BUSINESS_FAQ_URL = creatorAndBusinessFaqUrl
export const CREATOR_REGISTRATION_URL = creatorRegistrationUrl
export const CREATOR_BANK_ACCOUNT_REGISTRATION_URL = creatorBankAccountRegistrationUrl
export const SOCIAL_TWITTER_URL = socialTwitterUrl
export const SOCIAL_FACEBOOK_URL = socialFacebookUrl
export const SOCIAL_INSTAGRAM_URL = socialInstagramUrl
export const SOCIAL_YOUTUBE_URL = socialYoutubeUrl
export const HASHTAG = hashtag
export const META_DESCRIPTION = metaDescription

// ブランドに関係ない共通定数
export const FLASH_MESSAGE_ANIMATION_DURATION = 6000
